import {
  type DispatcherEvent,
  generateNativeMessageSender
} from '@carvana/merch-native';
import { isNonProd } from '~/constants/environment';
import { logError } from '~/utilities/errorHandlers';

export default function getSourcedSendMessageToNative(source: string) {
  return generateNativeMessageSender<DispatcherEvent>({
    logError,
    source,
    verboseLogs: isNonProd
  });
}
